import { useEffect } from "react";

/**
 * Cosmetic: a single crawling/flying fly from the vendored auz/Bug library
 * (front/public/bug/, WTFPL). Mounted only on the home page.
 *
 * Client-only: the library uses window/document and would break Next SSR, so it
 * is loaded and instantiated inside useEffect. Next basePath is '/web', so the
 * vendored public assets are served under '/web/bug/...'.
 */
const BUG_BASE = "/web/bug";
const SCRIPT_ID = "auz-bug-fly";

export default function BugAnimation() {
  useEffect(() => {
    let controller: any = null;
    let cancelled = false;

    const start = () => {
      const BugController = (window as any).BugController;
      if (cancelled || !BugController) return;
      // One fly, calm (ignores the cursor — no multiply/die).
      controller = new BugController({
        minBugs: 1,
        maxBugs: 1,
        mouseOver: "nothing",
        imageSprite: `${BUG_BASE}/fly-sprite.png`,
      });
    };

    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if ((window as any).BugController) {
      start();
    } else if (!existing) {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = `${BUG_BASE}/bug.js`;
      script.async = true;
      script.addEventListener("load", start);
      document.body.appendChild(script);
    } else {
      existing.addEventListener("load", start);
    }

    return () => {
      // Teardown so the fly doesn't follow the user to other pages.
      cancelled = true;
      try {
        controller?.end?.();
      } catch {
        /* no-op */
      }
      document.querySelectorAll("body > .bug").forEach((n) => n.remove());
    };
  }, []);

  return null;
}
